<ng-container>{{ appVersion }}</ng-container>
